import { render, staticRenderFns } from "./indexCf.vue?vue&type=template&id=ca10ad20&scoped=true"
import script from "./indexCf.vue?vue&type=script&lang=js"
export * from "./indexCf.vue?vue&type=script&lang=js"
import style0 from "./indexCf.vue?vue&type=style&index=0&id=ca10ad20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca10ad20",
  null
  
)

export default component.exports